import * as Sentry from '@sentry/react';
import {createBrowserRouter} from 'react-router';
import AppContainer from './AppContainer';
import RouteErrorBoundary from './RouteErrorBoundary';
import {authRoutes} from './auth/routes';
import {dashboardRoutes} from './dashboard/routes';

const sentryCreateBrowserRouter =
  Sentry.wrapCreateBrowserRouterV7(createBrowserRouter);

const router = sentryCreateBrowserRouter([
  {
    path: '/',
    element: <AppContainer />,
    // Catches render/loader errors from any descendant route and forwards them
    // to Sentry (the default React Router boundary swallows them silently).
    errorElement: <RouteErrorBoundary />,
    children: [
      {
        path: '',
        lazy: () => import('../screens/LandingPage'),
      },
      {
        path: 'auth',
        children: authRoutes,
      },
      {
        path: 'map',
        lazy: () => import('../screens/WeatherMap'),
      },
      {
        path: 'app',
        lazy: () => import('./dashboard'),
        children: dashboardRoutes,
      },
      {
        path: 'terms-and-conditions',
        lazy: () => import('../screens/legal/TermsOfService'),
      },
      {
        path: 'privacy-policy',
        lazy: () => import('../screens/legal/PrivacyPolicy'),
      },
      {
        path: 'account-deletion',
        lazy: () => import('../screens/legal/AccountDeletionInformation'),
      },
      {
        path: 'help',
        lazy: () => import('../screens/HelpCenter'),
        children: [
          {
            path: '',
            lazy: () => import('../screens/HelpCenter/ArticleListScreen'),
          },
          {
            path: 'category/:category',
            lazy: () => import('../screens/HelpCenter/CategoryScreen'),
          },
          {
            path: ':slug',
            lazy: () => import('../screens/HelpCenter/ArticleViewScreen'),
          },
        ],
      },
      {
        path: '*',
        lazy: async () => import('../screens/NotFound'),
      },
    ],
  },
]);

export default router;
